// extracted by mini-css-extract-plugin
export default {"header":"ContractDetails_header__e7A1K","link":"ContractDetails_link__YiWxc"};